import React from "react";
import { useRef } from "react";
import "./Join.css";
import emailjs from "@emailjs/browser";

const Join = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_s5uq3zs",
        "template_ezjqicq",
        form.current,
        "g2027bAiIuXPL5aYe"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span>Ready to </span>
          <span className="stroke-text">level up</span>
        </div>
        <div>
          <span className="stroke-text">your body </span>
          <span>with us?</span>
        </div>
      </div>

      <div className="right-j">
        <form
          ref={form}
          action=""
          className="email-container"
          onSubmit={sendEmail}
        >
          <input
            type="email"
            name="user_email"
            placeholder="Enter your Email Address here"
          />
          <button className="btn btn-join">Join now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
